import { useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';
import { useForm } from 'hooks/useForm';
import { createGroup } from '@redux/features/groupsSlice';
import SessionStorageUtils from 'utils/SessionStorageUtils';
import { groupSchema } from 'constants/formValidationSchemas/groupSchema';
import { SessionStorageKeys } from 'constants/sessionStorageKeys';
import { Checkbox } from 'components/Checkbox';
import { Dropdown } from 'components/Dropdown';
import { Button } from 'components/Button';
import { Input } from 'components/Input';
import { ClientSelectFields } from './ClientSelectFields';
import styles from 'pages/Database/Groups/Groups.scss';

export const CreateGroup = ({ setIsModalOpen }) => {
  const currentLocation = SessionStorageUtils.getData(SessionStorageKeys.LOCATION);
  const { isLoading, error } = useSelector((state) => state.groups);
  const { locations } = useSelector((state) => state.locations);
  const dispatch = useDispatch();

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    isValid,
    resetForm,
    setFieldValue,
    setFieldTouched,
  } = useForm({
    initialValues: {
      name: '',
      isClub: false,
      locationID: currentLocation?.admin ? null : currentLocation?.id,
      clients: [],
    },
    validationSchema: groupSchema,
    onSubmit: async (values) => {
      const payload = {
        ...values,
        locationID: Number(values.locationID),
        clients: values.clients.filter((id) => id !== null),
      };

      const result = await dispatch(createGroup(payload));

      if (result.meta?.requestStatus === 'fulfilled') {
        resetForm();
        setIsModalOpen(false);
      }
    },
    status: {
      isLoading,
      error,
    },
  });

  const locationsOptions = useMemo(
    () => locations.map((location) => ({ label: location.name, value: location.id })),
    [locations]
  );

  return (
    <form onSubmit={handleSubmit}>
      <h3 className={styles.title}>Створення групи</h3>
      {currentLocation?.admin && (
        <Dropdown
          className={styles.dropdown}
          options={locationsOptions}
          placeholder='Оберіть локацію'
          value={locationsOptions.find((opt) => opt.value === values.locationID)}
          onChange={(option) => setFieldValue('locationID', option?.value || null)}
          errorText={touched.locationID && errors.locationID}
          invalid={touched.locationID && !!errors.locationID}
          onBlur={() => handleBlur({ target: { name: 'locationID' } })}
        />
      )}
      <Input
        className={styles.input}
        value={values.name}
        name='name'
        placeholder='Назва групи'
        errorText={touched.name && errors.name}
        invalid={touched.name && !!errors.name}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Checkbox
        className={styles.checkbox}
        label='Група клубу "M.U.ST Dance&Win"'
        checked={values.isClub}
        onChange={(e) => setFieldValue('isClub', e.target.checked)}
        id='isClub-checkbox'
      />
      <ClientSelectFields
        value={values.clients}
        onChange={(newValues) => setFieldValue('clients', newValues)}
        onBlur={() => setFieldTouched('clients', true)}
        error={touched.clients && errors.clients}
      />
      <Button className={styles.formCreateBtn} text='Створити' type='submit' disabled={!isValid || isSubmitting} />
    </form>
  );
};
